import React from "react";
import { Card, CardActionArea, Box, Typography, Chip } from "@mui/material";
import { formatPrice, displayCustomerName } from "../utils/helpers";

const STATUS_COLOR = {
  processing: "primary",
  modifying: "warning",
  dispatched: "info",
  completed: "success",
  cancelled: "error",
  placed: "secondary",
  created: "default",
};

const TYPE_LABEL = { dine_in: "Table", delivery: "Delivery", take_away: "Takeaway" };

export default function OrderCard({ order, currency, onPress }) {
  const itemCount = (order.order_items || []).filter((i) => i.status !== 2).reduce((n, i) => n + i.quantity, 0);
  const customerName = displayCustomerName(order);

  return (
    <Card variant="outlined" sx={{ mb: 1.25, borderRadius: 2 }}>
      <CardActionArea onClick={() => onPress?.(order)} sx={{ p: 1.5 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <Box>
            <Typography variant="subtitle2" fontWeight={700}>
              #{order.order_no || order.id}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {TYPE_LABEL[order.order_type] || order.order_type}
              {order.order_type === "dine_in" && order.store_table ? ` · ${order.store_table.name}` : ""}
              {customerName ? ` · ${customerName}` : ""}
            </Typography>
          </Box>
          <Chip label={order.status} size="small" color={STATUS_COLOR[order.status] || "default"} sx={{ textTransform: "capitalize" }} />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
          <Typography variant="caption" color="text.secondary">
            {itemCount} item{itemCount === 1 ? "" : "s"}
          </Typography>
          <Typography variant="subtitle2" fontWeight={700}>
            {formatPrice(order.grand_total ?? order.subtotal, currency)}
          </Typography>
        </Box>
      </CardActionArea>
    </Card>
  );
}
